import React from 'react';
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
  ZoomableGroup,
} from 'react-simple-maps';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import styled from 'styled-components';
import Flag from 'react-world-flags';
import { motion } from 'framer-motion';

// List of countries with ISO Alpha-2 codes and names
const countriesList = [
  { code: 'US', name: 'United States' },
  { code: 'AU', name: 'Australia' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'CA', name: 'Canada' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'BR', name: 'Brazil' },
  { code: 'SA', name: 'Saudi Arabia' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'FI', name: 'Finland' },
  { code: 'JP', name: 'Japan' },
  { code: 'IE', name: 'Ireland' },
  { code: 'AE', name: 'Dubai (UAE)' },
  { code: 'SG', name: 'Singapore' },
  { code: 'DK', name: 'Denmark' },
  { code: 'KW', name: 'Kuwait' },
  { code: 'QA', name: 'Qatar' },
  { code: 'IN', name: 'India' },
  { code: 'ZA', name: 'South Africa' },
  { code: 'SE', name: 'Sweden' },
  { code: 'NO', name: 'Norway' },
];

const geoUrl = 'https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json';

const MapContainer = styled.div`
  width: 100%;
  background: #f8f9fa;
  padding: 2rem 1rem;
  border-radius: 12px;

  .marker-dot {
    fill: rgb(177, 33, 172);
    stroke: #fff;
    stroke-width: 1px;
    cursor: pointer;
    transition: fill 0.2s ease;
  }

  .marker-dot:hover {
    fill: rgb(25, 0, 255);
  }
`;

const WorldwideCountries = () => {
  return (
    <><motion.section id="testimonials" className="container my-5"
      initial={{ y: 30, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      viewport={{ once: false, amount: 0.6 }}
      transition={{ duration: 0.8, ease: "easeOut" }}>
      <div className="d-flex align-items-center justify-content-center text-center flex-wrap">

        <div
          className="px-3 fw-bold responsive-heading"
        >
         Extending Our   <span className="highlight-orange">Services</span> To Countries Around <span className="highlight-orange">The Globe</span>
        </div>

      </div>
    </motion.section>
      <div className="container my-5">
        <MapContainer>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.2 }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
          >
            <ComposableMap
              projectionConfig={{ scale: 140 }}
              width={980}
              height={400}
              style={{ width: '100%', height: 'auto' }}
            >
              <ZoomableGroup zoom={1} disableZoom>
                <Geographies geography={geoUrl}>
                  {({ geographies }) => geographies.map((geo) => {
                    const isMarked = countriesList.some(
                      (c) => c.code === geo.properties.ISO_A2
                    );
                    return (
                      <Geography
                        key={geo.rsmKey}
                        geography={geo}
                        fill={isMarked ? '#ffe0b3' : '#EAEAEC'}
                        stroke="#D6D6DA" />
                    );
                  })}
                </Geographies>

                {countriesList.map(({ code, name }) => {
                  const coords = getCoordByCode(code);
                  return (
                    <Marker key={code} coordinates={coords}>
                      <circle
                        r={5}
                        className="marker-dot"
                        data-tooltip-id="world-map-tooltip"
                        data-tooltip-content={`
                        <div style="display:flex;align-items:center;gap:6px;">
                          <img src="https://flagcdn.com/24x18/${code.toLowerCase()}.png" width="20" alt="${name}" />
                          <span>${name}</span>
                        </div>
                      `} />
                    </Marker>
                  );
                })}
              </ZoomableGroup>
            </ComposableMap>
            <Tooltip
              id="world-map-tooltip"
              render={({ content }) => (
                <div dangerouslySetInnerHTML={{ __html: content }} />
              )} />
          </motion.div>
        </MapContainer>
      </div></>
  );
};

// Country lat/lon map
function getCoordByCode(code) {
  const coordMap = {
    US: [-98.5, 39.8],
    AU: [133.8, -25.3],
    NZ: [174.8, -41.3],
    CA: [-106.3, 56.1],
    GB: [-3.4, 55],
    BR: [-51.9, -14.2],
    SA: [45, 24],
    NL: [5.3, 52.1],
    FI: [25.7, 61.9],
    JP: [138.2, 36.2],
    IE: [-8.2, 53.1],
    AE: [54.4, 24.5],
    SG: [103.8, 1.35],
    DK: [10.4, 56],
    KW: [47.5, 29.3],
    QA: [51.2, 25.2],
    IN: [78.9, 21],
    ZA: [22.9, -30.6],
    SE: [18.6, 60.1],
    NO: [8.5, 60.4],
  };
  return coordMap[code] || [0, 0];
}

export default WorldwideCountries;
